import * as server from "@/utils/http"

export const _getPhysicalFormByPackage = params => server.get("/required-item-config/getPhysicalFormByPackage", params);


